import { BusinessRequest, BusinessCustomRequestOptions } from "../utils";

const apis = {
  relatedCompany: {
    prefix: "/api/manager",

    /**
     * @description 创建或更新外部公司(会关联或创建租户)
     * @alias /api/manager/company/outer/rel_or_create/tenant
     * @doc https://test-internal.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/updateOrCreateCompanyIncludeTenantUsingPOST
     */
    createOrUpdateTenant: {
      post: "/company/outer/rel_or_create/tenant",
    },

    /**
     * @description 判断公司名称是否存在租户
     * @alias /api/manager/company/{name}/tenant/exist
     * @doc https://test-internal.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/existTenantUsingPOST
     */
    isExistTenant: {
      post: "company/{name}/tenant/exist",
    },

    /**
     * @description 按公司分类查询关联方式列表
     * @alias /api/manager/company/rel_types
     * @doc https://test-internal.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/getRelTypesUsingGET
     */
    getRelTypes: {
      get: "/company/rel_types",
    },

    /**
     * @description 根据id获取公司详情
     * @alias /api/manager/company/{id}
     * @doc https://test-internal.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/getCompanyInfoByIdUsingGET
     */
    getCompanyDetail: {
      get: "/company/{id}",
    },
  },
};

const { useRequest } = new BusinessRequest(apis, BusinessCustomRequestOptions);

export { apis, useRequest };
